module.exports = __webpack_public_path__ + "img/8M.712a43bb.png";